// utils/txAdEnums.js

/**
 * TX广告商枚举值
 */

// 客户系统状态
export const CUSTOMER_STATUS = {
    'CUSTOMER_STATUS_NORMAL': '有效',
    'CUSTOMER_STATUS_PENDING': '待审核',
    'CUSTOMER_STATUS_DENIED': '审核不通过',
    'CUSTOMER_STATUS_FROZEN': '封停',
    'CUSTOMER_STATUS_TOBE_ACCEPTED': '待接受',
    'CUSTOMER_STATUS_TOBE_ACTIVATED': '待激活',
    'CUSTOMER_STATUS_SUSPEND': '暂停',
    'CUSTOMER_STATUS_MATERIAL_PREPARED': '广告主资料准备',
    'CUSTOMER_STATUS_DELETED': '删除',
    'CUSTOMER_STATUS_FROZEN_TEMPORARILY': '临时冻结',
    'CUSTOMER_STATUS_UNREGISTERED': '未注册'
}

// 广告状态
export const ADGROUP_STATUS = {
    'ADGROUP_STATUS_FROZEN': '已冻结',
    'ADGROUP_STATUS_SUSPEND': '暂停中',
    'ADGROUP_STATUS_NOT_IN_DELIVERY_TIME': '广告未到投放时间',
    'ADGROUP_STATUS_ACTIVE': '投放中',
    'ADGROUP_STATUS_DELETED': '已删除',
    'ADGROUP_STATUS_ACCOUNT_BALANCE_NOT_ENOUGH': '账户余额不足',
    'ADGROUP_STATUS_DAILY_BUDGET_REACHED': '广告达到日预算上限',
    'ADGROUP_STATUS_PARTIAL_ACTIVE': '部分投放中',
    'ADGROUP_STATUS_WECHAT_CHANNELS_STOP': '投放结束（超过14天广告未上线）',
    'ADGROUP_STATUS_CREATIVE_STATUS_PENDING': '创意未投放',
    'ADGROUP_STATUS_CREATIVE_EMPTY': '创意准备中',
    'ADGROUP_STATUS_JOINT_BUDGET_REACHED': '广告被暂停（联合预算达上限）',
    'ADGROUP_STATUS_TOTAL_BUDGET_REACHED': '广告达到总预算上限',
    'ADGROUP_STATUS_PRE_LOCK': '待锁定预算',
    'ADGROUP_STATUS_UNLOCKING': '解锁预算中',
    'ADGROUP_STATUS_STOP': '投放结束',
    'ADGROUP_STATUS_LIVE_NOT_ACTIVE': '已到达投放时间（直播未开启）',
    'ADGROUP_STATUS_NOT_ACTIVE_PRODUCT_AUDIT_FAIL': '广告未投放（推广产品审核不通过）',
    'ADGROUP_STATUS_LIVE_VIOLATION': '广告未投放（直播间违规）',
    'ADGROUP_STATUS_WECHAT_STORE_PENDING': '广告未投放（店铺审核中）',
    'ADGROUP_STATUS_WECHAT_STORE_CLOSING': '广告未投放（店铺关闭中）',
    'ADGROUP_STATUS_WECHAT_STORE_CLOSED': '广告未投放（店铺已关闭）',
    'ADGROUP_STATUS_NOT_ACTIVE_PRODUCT_REMOVED': '广告未投放（商品已下架）'
}

// 创意状态
export const DYNAMIC_CREATIVE_STATUS = {
    'DYNAMIC_CREATIVE_STATUS_ACTIVE': '活跃',
    'DYNAMIC_CREATIVE_STATUS_SUSPEND': '暂停',
    'DYNAMIC_CREATIVE_STATUS_PENDING': '待审核'
}

// 配置状态
export const CONFIGURED_STATUS = {
    'AD_STATUS_NORMAL': '正常',
    'AD_STATUS_SUSPEND': '暂停',
    'AD_STATUS_PENDING': '待审核'
}

// 优化目标
export const OPTIMIZATION_GOAL = {
    'OPTIMIZATIONGOAL_NONE': '无',
    'OPTIMIZATIONGOAL_BRAND_CONVERSION': '品牌转化',
    'OPTIMIZATIONGOAL_FOLLOW': '关注',
    'OPTIMIZATIONGOAL_CLICK': '点击',
    'OPTIMIZATIONGOAL_IMPRESSION': '曝光',
    'OPTIMIZATIONGOAL_APP_DOWNLOAD': '下载',
    'OPTIMIZATIONGOAL_APP_ACTIVATE': '激活',
    'OPTIMIZATIONGOAL_APP_REGISTER': '注册',
    'OPTIMIZATIONGOAL_ONE_DAY_RETENTION': '次日留存',
    'OPTIMIZATIONGOAL_APP_PURCHASE': '付费次数',
    'OPTIMIZATIONGOAL_ECOMMERCE_ORDER': '下单',
    'OPTIMIZATIONGOAL_ECOMMERCE_CHECKOUT': 'H5 购买',
    'OPTIMIZATIONGOAL_LEADS': '销售线索',
    'OPTIMIZATIONGOAL_ECOMMERCE_CART': '加入购物车',
    'OPTIMIZATIONGOAL_PROMOTION_CLICK_KEY_PAGE': '公众号内注册',
    'OPTIMIZATIONGOAL_VIEW_COMMODITY_PAGE': '商品详情页浏览',
    'OPTIMIZATIONGOAL_ONLINE_CONSULTATION': '在线咨询',
    'OPTIMIZATIONGOAL_TELEPHONE_CONSULTATION': '电话拨打',
    'OPTIMIZATIONGOAL_PAGE_RESERVATION': '表单预约',
    'OPTIMIZATIONGOAL_DELIVERY': '发货',
    'OPTIMIZATIONGOAL_MESSAGE_AFTER_FOLLOW': '公众号内发消息',
    'OPTIMIZATIONGOAL_CLICK_MENU_AFTER_FOLLOW': '公众号内点击菜单栏',
    'OPTIMIZATIONGOAL_PAGE_EFFECTIVE_ONLINE_CONSULT': '有效在线咨询',
    'OPTIMIZATIONGOAL_APPLY': '完件',
    'OPTIMIZATIONGOAL_CONFIRM_EFFECTIVE_LEADS_CONSULT': '有效在线咨询',
    'OPTIMIZATIONGOAL_CONFIRM_EFFECTIVE_LEADS_PHONE': '有效电话拨打',
    'OPTIMIZATIONGOAL_LEADS_COLLECT': '综合线索收集',
    'OPTIMIZATIONGOAL_FIRST_PURCHASE': '首次付费',
    'OPTIMIZATIONGOAL_PRE_CREDIT': '预授信',
    'OPTIMIZATIONGOAL_CREDIT': '授信',
    'OPTIMIZATIONGOAL_WITHDRAW_DEPOSITS': '提现',
    'OPTIMIZATIONGOAL_PROMOTION_VIEW_KEY_PAGE': '关键页面访问次数',
    'OPTIMIZATIONGOAL_MOBILE_APP_CREATE_ROLE': '小游戏创角',
    'OPTIMIZATIONGOAL_CANVAS_CLICK': '跳转按钮点击',
    'OPTIMIZATIONGOAL_PROMOTION_CLAIM_OFFER': '领券',
    'OPTIMIZATIONGOAL_ECOMMERCE_ADD_TO_WISHLIST': '商品收藏',
    'OPTIMIZATIONGOAL_CONFIRM_EFFECTIVE_LEADS_RESERVATION': '有效表单提交',
    'OPTIMIZATIONGOAL_PAGE_RECEIPT': '签收',
    'OPTIMIZATIONGOAL_PAGE_SCAN_CODE': '加企业微信客服',
    'OPTIMIZATIONGOAL_SELECT_COURSE': '选课',
    'OPTIMIZATIONGOAL_CONFIRM_POTENTIAL_CUSTOMER_PHONE': '电话潜在客户',
    'OPTIMIZATIONGOAL_MOBILE_APP_AD_INCOME': '广告变现',
    'OPTIMIZATIONGOAL_MOBILE_APP_ACCREDIT': '小游戏授权',
    'OPTIMIZATIONGOAL_PURCHASE_MEMBER_CARD': '首次会员购买',
    'OPTIMIZATIONGOAL_PAGE_CONFIRM_EFFECTIVE_LEADS': '有效综合线索',
    'OPTIMIZATIONGOAL_RESERVATION': '微信流量预约行为',
    'OPTIMIZATIONGOAL_FIRST_ECOMMERCE_ORDER': '首次下单',
    'OPTIMIZATIONGOAL_LIKE': '点赞',
    'OPTIMIZATIONGOAL_ADD_DESKTOP': '快应用加桌面',
    'OPTIMIZATIONGOAL_EXTERNAL_LINK_CLICK': '外链点击',
    'OPTIMIZATIONGOAL_BUY_COUPONS': '购券',
    'OPTIMIZATIONGOAL_LEAVE_INFORMATION': '咨询留资',
    'OPTIMIZATIONGOAL_CORE_ACTION': '关键行为',
    'OPTIMIZATIONGOAL_ONE_DAY_RETENTION_RATIO': '次留率',
    'OPTIMIZATIONGOAL_PROMOTION_READ_ARTICLE': '阅读文章',
    'OPTIMIZATIONGOAL_FIRST_TWENTY_FOUR_HOUR_ECOMMERCE_ORDER': '24 小时下单',
    'OPTIMIZATIONGOAL_ECOMMERCE_SCANCODE_WX': '扫码加粉',
    'OPTIMIZATIONGOAL_MOBILE_APP_SEVEN_DAYS_RETENTION': '7 日留存',
    'OPTIMIZATIONGOAL_CLASS_PARTICIPATED': '首次到课',
    'OPTIMIZATIONGOAL_INSURANCE_PURCHASE': '保险支付',
    'OPTIMIZATIONGOAL_RESERVATION_CHECK': '意向表单',
    'OPTIMIZATIONGOAL_OPEN_ACCOUNT': '券商开户',
    'OPTIMIZATIONGOAL_SEVEN_DAY_ECOMMERCE_ORDER': '7 日下单',
    'OPTIMIZATIONGOAL_ADD_WECHAT': '添加个人微信客服',
    'OPTIMIZATIONGOAL_WECOM_CONSULT': '加企微后咨询',
    'OPTIMIZATIONGOAL_ADD_GROUP': '加群',
    'OPTIMIZATIONGOAL_QUICK_ORDER': '快速下单',
    'OPTIMIZATIONGOAL_PRE_PAY': '预付定金',
    'OPTIMIZATIONGOAL_PAGE_ONLINE_CONSULT_ACTIVE_ONE_MSG': '主动一句话咨询',
    'OPTIMIZATIONGOAL_CALL_DURATION_THIRTY_SECONDS': '通话 30S',
    'OPTIMIZATIONGOAL_CLAIM_COURSE': '领课',
    'OPTIMIZATIONGOAL_QUIT_GROUP': '退群',
    'OPTIMIZATIONGOAL_VIEW_ACQUISITION_CONTENT': '拉新访问关键页面',
    'OPTIMIZATIONGOAL_BACK_FLOW': '沉默唤起',
    'OPTIMIZATIONGOAL_PAGE_ONLINE_CONSULT_THREE_MSG': '三句话咨询',
    'OPTIMIZATIONGOAL_RENEWAL': '保险续费',
    'OPTIMIZATIONGOAL_LOW_PRICE_COURSE': '低价课转化',
    'OPTIMIZATIONGOAL_CONSULT_INTENTION': '开口后下单意向',
    'OPTIMIZATIONGOAL_EVERY_DAY_RETENTION': '七日内每次留存成本',
    'OPTIMIZATIONGOAL_PROMOTION_VIEW_KEY_PAGE_UV': '关键页面访问人数',
    'OPTIMIZATIONGOAL_LIVE_STREAM_DURATION_1MIN': '直播观看一分钟',
    'OPTIMIZATIONGOAL_LIVE_STREAM_INTERACTION': '直播互动',
    'OPTIMIZATIONGOAL_ECOMMERCE_CANCEL_ORDER': '取消订单率',
    'OPTIMIZATIONGOAL_CLICK_LEADS_COMPONENT': '点击留资组件',
    'OPTIMIZATIONGOAL_REGULAR_PRICE_COURSE': '正价课',
    'OPTIMIZATIONGOAL_VISIT_STROE': '到店',
    'OPTIMIZATIONGOAL_EFFECTIVE_ENTRY': '每日首次启动',
    'OPTIMIZATIONGOAL_CREDIT_RATIO': '完件授信率',
    'OPTIMIZATIONGOAL_QYT_LIVE_STREAM_DEAL': '全域通直播间成交',
    'OPTIMIZATIONGOAL_QYT_LIVE_STREAM_PRODUCT_CLICK': '全域通直播间商品点击',
    'OPTIMIZATIONGOAL_QYT_LIVE_STREAM_AUDIENCE': '全域通直播间观众',
    'OPTIMIZATIONGOAL_QYT_LIVE_STREAM_COMMENT': '全域通直播评论次数',
    'OPTIMIZATIONGOAL_QYT_LIVE_STREAM_FANS': '全域通直播间涨粉',
    'OPTIMIZATIONGOAL_24H_FIRSTPAY': '首日首次付费',
    'OPTIMIZATIONGOAL_STORE_STAY': '店铺停留',
    'OPTIMIZATIONGOAL_LOW_PRICE_INSURANCE_PAYMENT': '低价险支付',
    'OPTIMIZATIONGOAL_UNDERWRITING': '贷款额度开通',
    'OPTIMIZATIONGOAL_FIRST_WITHDRAW': '借款',
    'OPTIMIZATIONGOAL_BRIDGING_COURSE_COMPLETED': '先导课完课',
    'OPTIMIZATIONGOAL_THIRTY_SECONDS_SCANCODE_WX': '浏览三十秒扫码加粉',
    'OPTIMIZATIONGOAL_FIRST_TWENTY_FOUR_HOUR_REFUND_RATE': '24 小时退款率',
    'OPTIMIZATIONGOAL_VIEW_DRAMA_DURATION_1MIN': '观看转化',
    'OPTIMIZATIONGOAL_FIRST_PROMPT_INPUT': '首次发送提示语',
    'OPTIMIZATIONGOAL_ECOMMERCE_GIFTING': '送礼下单',
    'OPTIMIZATIONGOAL_CLUE_PAY_SUCCEED': '支付后存在意向',
    'OPTIMIZATIONGOAL_30DAY_UNSUBSCRIBE_RATE': '30 日退订率'
}

// 投放站点
export const SITE_SET = {
    'SITE_SET_MOMENTS': '朋友圈',
    'SITE_SET_SEARCH_SCENE': '搜索场景',
    'SITE_SET_ARTICLE': '公众号文章',
    'SITE_SET_MOBILE_UNION': '优量汇',
    'SITE_SET_WECHAT': '微信公众号与小程序',
    'SITE_SET_TENCENT_NEWS': '腾讯新闻',
    'SITE_SET_TENCENT_VIDEO': '腾讯视频',
    'SITE_SET_MOBILE_YYB': '应用宝',
    'SITE_SET_PCQQ': '腾讯广告电脑端（PC）',
    'SITE_SET_KANDIAN': 'QQ浏览器（原腾讯看点）',
    'SITE_SET_QQ_MUSIC_GAME': 'QQ、腾讯音乐及游戏',
    'SITE_SET_CHANNELS': '微信视频号',
    'SITE_SET_WECHAT_SEARCH': '微信搜一搜',
    'SITE_SET_WECHAT_PLUGIN': '微信新闻插件', // 添加这个缺失的枚举值
    'SITE_SET_QBSEARCH': 'QQ浏览器等',
    'SITE_SET_SEARCH_MOBILE_UNION': '搜索优量汇',
    'SITE_SET_SMART': '自动版位'
}

// 账号类型
export const ACCOUNT_TYPE = {
    'ACCOUNT_TYPE_WECHAT': '微信账号',
    'ACCOUNT_TYPE_QQ': 'QQ账号',
    'ACCOUNT_TYPE_UNKNOWN': '未知',
    'ACCOUNT_TYPE_ADVERTISER': '广告主',
    'ACCOUNT_TYPE_AGENCY': '代理商',
    'ACCOUNT_TYPE_DSP': 'DSP',
    'ACCOUNT_TYPE_DEVELOPER': '开发者',
    'ACCOUNT_TYPE_MEMBER': '流量主',
    'ACCOUNT_TYPE_EXTERNAL_SUPPLIER': '创意供应商'
}

// 用户ID类型
export const USER_ID_TYPE = {
    'USER_ID_TYPE_WECHAT_ID': '微信ID',
    'USER_ID_TYPE_QQ_ID': 'QQ ID'
}

/**
 * 获取状态对应的标签类型
 */
export const getStatusType = (status) => {
    const typeMap = {
        'CUSTOMER_STATUS_NORMAL': 'success',
        'CUSTOMER_STATUS_PENDING': 'warning',
        'CUSTOMER_STATUS_DENIED': 'danger',
        'ADGROUP_STATUS_ACTIVE': 'success',
        'ADGROUP_STATUS_SUSPEND': 'warning',
        'ADGROUP_STATUS_PENDING': 'info',
        'DYNAMIC_CREATIVE_STATUS_ACTIVE': 'success',
        'DYNAMIC_CREATIVE_STATUS_SUSPEND': 'warning',
        'DYNAMIC_CREATIVE_STATUS_PENDING': 'info',
        'AD_STATUS_NORMAL': 'success',
        'AD_STATUS_SUSPEND': 'warning',
        'AD_STATUS_PENDING': 'info'
    }
    return typeMap[status] || 'info'
}

/**
 * 获取状态文本
 */
export const getStatusText = (status) => {
    // 优先在客户状态中查找
    if (CUSTOMER_STATUS[status]) {
        return CUSTOMER_STATUS[status]
    }
    // 然后在广告状态中查找
    if (ADGROUP_STATUS[status]) {
        return ADGROUP_STATUS[status]
    }
    // 最后在创意状态中查找
    if (DYNAMIC_CREATIVE_STATUS[status]) {
        return DYNAMIC_CREATIVE_STATUS[status]
    }
    // 在配置状态中查找
    if (CONFIGURED_STATUS[status]) {
        return CONFIGURED_STATUS[status]
    }
    return status
}

/**
 * 获取广告状态文本
 */
export const getAdStatusText = (status) => {
    return ADGROUP_STATUS[status] || status
}

/**
 * 获取创意状态文本
 */
export const getCreativeStatusText = (status) => {
    return DYNAMIC_CREATIVE_STATUS[status] || status
}

/**
 * 获取配置状态文本
 */
export const getConfigStatusText = (status) => {
    return CONFIGURED_STATUS[status] || status
}

/**
 * 获取优化目标文本
 */
export const getOptimizationGoalText = (goal) => {
    return OPTIMIZATION_GOAL[goal] || goal
}

/**
 * 获取投放站点文本
 */
export const getSiteSetText = (siteSet) => {
    if (!siteSet) return ''
    
    let siteArray = []
    
    // 如果是字符串，尝试解析为数组
    if (typeof siteSet === 'string') {
      try {
        siteArray = JSON.parse(siteSet)
      } catch (error) {
        console.error('解析投放站点数据失败:', error)
        return siteSet
      }
    } 
    // 如果是数组，直接使用
    else if (Array.isArray(siteSet)) {
      siteArray = siteSet
    }
    // 其他情况返回空
    else {
      return ''
    }
    
    // 处理数组中的每个站点
    const siteTexts = siteArray.map(site => SITE_SET[site] || site)
    return siteTexts.join('、')
  }

/**
 * 获取用户ID类型文本
 */
export const getUserIdTypeText = (type) => {
    return USER_ID_TYPE[type] || type
}

export default {
    CUSTOMER_STATUS,
    ADGROUP_STATUS,
    DYNAMIC_CREATIVE_STATUS,
    CONFIGURED_STATUS,
    OPTIMIZATION_GOAL,
    SITE_SET,
    ACCOUNT_TYPE,
    USER_ID_TYPE,
    getStatusType,
    getStatusText,
    getAdStatusText,
    getCreativeStatusText,
    getConfigStatusText,
    getOptimizationGoalText,
    getSiteSetText,
    getUserIdTypeText
}